import React from 'react'
import ButtonDeprecated from "../../../gd-components/buttons/gd-button/gd-button"
import {ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new";

type Props = {
    className?      : string

    label?          : string
    size?           : 'small' | '30' | '24' | '26' | '28' | '32'
    type?           : string

    icon?           : string
    iconPosition    : 'left' | 'right'

    form            : any

    hideIfDisabled? : boolean // hide (no render) when form not ready for submit

    onClick?        : func
}

export default class ButtonSubmit2 extends React.Component<Props> {

    private form: any

    static defaultProps = {
        iconPosition: 'left'
    };

    constructor(props: Props) {
        super(props)

        this.form = this.props.form
    }

    componentDidMount() {
        if (this.form) this.form.registerSubmitButton(this)
    }

    setForm = (form: any) => {
        if (!this.form) {
            this.form = form
            this.form.registerSubmitButton(this)
            this.forceUpdate()
        } else console.warn("ButtonSubmitNew setForm error: form already set")
    };

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if (this.props.type === 'busy') {
            e.preventDefault()
        } else {
            if (this.form) this.form.onSubmitClick.call(this.form)
            else if(this.props.onClick) this.props.onClick()
        }
    };

    render() {
        let type = ButtonType.PRIMARY

        if (this.form) {
            if (this.form.isSubmitting) type = ButtonType.BUSY
            else if (this.form.isFormValid && this.form.isFormChanged) type = ButtonType.PRIMARY
        }

        if (this.props.hideIfDisabled === true && type !== ButtonType.PRIMARY && type !== ButtonType.BUSY) return null

        return (
            <ButtonDeprecated onClick={this.onClick}
                              size={this.props.size}
                              type={type}
                              label={this.props.label!}
                              icon={this.props.icon}
                              iconPosition={this.props.iconPosition}
                              className={this.props.className}/>
        );
    }
}